<template>
  <div class="donor" v-if="page">
    <h2 class="block-title">รายชื่อผู้ร่วมบริจาค <span class="donor-count">({{ totalDonors | comma }} คน)</span></h2>
    <ul class="donor-list" v-if="donors.length > 0">
      <li class="donor-item" v-for="donor in donors">
        <div class="donor-item-icon"></div>
        <div class="donor-item-user">{{ donor.name }}<br /><span class="donor-item-date">{{ donor.date }}</span><br />
        <span class="donor-item-message" v-if="donor.message">{{ donor.message }}</span></div>
      </li>
    </ul>
    <div v-if="donors.length === 0" class="text-center no-donor">ยังไม่มีผู้ร่วมบริจาค</div>
    <loader v-if="showLoading" />
    <div class="w-30 mt-15 mb-20" v-if="showLoadMore">
      <a href="#" class="btn btn--white btn--sm" @click.prevent="loadMore">ดูเพิ่ม</a>
    </div>
  </div> <!-- donor -->
</template>

<script>
  import Loader from './Loader'

  const moment = require('moment')
  moment.locale('th_TH')

  export default {
    name: 'DonorList',

    components: {
      Loader
    },

    props: {
      page: {
        type: Object,
        required: true,
        default: null
      },
      ipp: {
        type: Number,
        default: 20
      }
    },

    data () {
      return {
        donors: [],
        showLoading: false,
        showLoadMore: false,
        totalDonors: 0
      }
    },

    created () {
      if (this.page) {
        this.fetch()
      }
    },

    methods: {
      fetch (page) {
        if (!this.params) {
          this.params = {
            ref_obj_type: 'page',
            ref_obj_id: this.page.id,
            ipp: this.ipp
          }
        }
        this.params.page = page || 1
        this.params.offset = (this.params.page - 1) * this.params.ipp

        this.$http.get(`invoice-products`, { params: this.params })
          .then(resp => {
            this.showLoading = false
            if (resp.body.invoice_product_list) {
              resp.body.invoice_product_list.forEach(inv => {
                try {
                  inv.data = JSON.parse(inv.data)
                } catch (err) {
                  console.log(err)
                  inv.data = {}
                }
                if (typeof inv.data.name === 'string') {
                  inv.data.name = inv.data.name.trim()
                } else {
                  inv.data.name = ''
                }
                this.donors.push({
                  name: inv.data.name || 'ไม่ประสงค์ออกนาม',
                  message: inv.data.message || '',
                  date: this.formatDate(inv.created)
                })
              })

              const pager = resp.body.pager
              this.showLoadMore = pager && pager.count >= this.params.ipp
              this.totalDonors = pager ? pager.total : 0
            }
          })
          .catch(err => {
            console.log(err)
            this.showLoading = false
          })
      },

      loadMore () {
        this.showLoading = true
        this.showLoadMore = false

        setTimeout(() => {
          this.fetch(this.params.page + 1)
        }, 500)
      },

      formatDate (timestamp) {
        const m = moment(timestamp)
        return `${m.format('D MMM')} ${parseInt(m.format('YYYY')) + 543} ${m.format('HH:mm:ss')}`
      }
    }
  }
</script>

<style lang="scss" scoped>
  .donor {
    .donor-count {
      font-size: 17px;
      font-weight: 300;
    }
    .donor-list {
      list-style: none;
      padding: 0;
      > .donor-item {
        padding-bottom: 0.5em;
        // border-bottom: 1px solid #ccc;
        .donor-item-icon {
          background: url("../../src/assets/img/ic-donor@2x.png") no-repeat left 5px;
          background-size: 40px;
          width: 50px;
          height: 50px;
          float: left;
        }
        .donor-item-user {
          margin-left: 50px;
          font-weight: 500;
          line-height: 1.2em;
        }
        .donor-item-date {
          font-weight: 300;
          font-size: 13px;
          line-height: 1.5em;
          color: #aaa;
        }
        .donor-item-message {
          font-weight: 400;
          display: inline-block;
          padding: 0.5em 0 0;
        }
      }
    }
    .no-donor {
      color: #B0B0B0;
      padding: 2em 0;
    }
  }
</style>



// WEBPACK FOOTER //
// DonorList.vue?68cb50a0